export const TRANSLATIONS_KEY = 'wisden_translations';

export const LOGIN_TOKEN_NAME = 'wisden-quiz-token';

export const LOGIN_TOKEN = 'wisden-login-token';

export const DEFAULT_API_VERSION = 'v2';

export const OFFSET_COUNTDOWN_SECONDS = 1;

export const PLATFORM_ID = 1;

export const WISDEN_QUIZ_USER_ID = 'wisden_quiz_user';

export const WISDEN_QUIZ_NEWSLETTER_SUBSCRIBED = 'isNewsletterSubbed';

export const NO_CLICK_CLASS = 'si-no-click';

export const MAIN_CONTAINER = '.si-main-component';

export const TRACKING_ELEMENT_ID = 'track';

export const EVENT_TRACKING_KEY = 'track-event';

export const QUIZ_PLAYED_ATLEAST_ONCE = 'hasPlayedQuizAtleastOnce';

export const SOCIAL_SHARING_MESSAGE = 'I just played the Wisden Cricket Daily Quiz!';

export const SOCIAL_SHARING_TOPICAL_MESSAGE = 'I just played the Wisden Cricket Topical Quiz!';

export const SOCIAL_SHARING_TITLE = 'Quiz';

export const ROOT_ELEMENT = 'root-wisden-quiz';

export const QUIZ_ID_DATA_ATTR = 'data-quiz-id';

export const QUIZ_TYPE_DATA_ATTR = 'data-quiz-type';

export const QUIZ_TYPE_TOPICAL = 'TOPICAL';

export const QUIZ_TYPE_ARCHIVE = 'ARCHIVE';

export const FIXED_CACHE_KEYS = {
  FIFTY_FIFTY: 'fiftyFifty',
  THIRD_UMPIRE: 'thirdUmpire'
};

export const BOOSTERS = {
  FIFTY_FIFTY: 'fiftyFifty',
  THIRD_UMPIRE: 'thirdUmpire'
};

export const FACEBOOK_SHARE_URL =
  'https://www.facebook.com/sharer/sharer.php?u={QUIZ_REDIRECT_URL}';
export const TWITTER_SHARE_URL =
  'http://twitter.com/share?text={MESSAGE}&url={QUIZ_REDIRECT_URL}&hashtags={HASHTAGS}';
export const QUIZ_ARENA_BASE_URL = window.location.href;

export const SHARE_TYPES = [
  { icon: 'qz-fb', shareFn: 'facebook' },
  { icon: 'qz-x', shareFn: 'twitter' },
  { icon: 'qz-copy', shareFn: 'copy' }
];

export const ICONS = {
  RIGHT_ARROW: 'qz-arrow-right',
  FIFTY_FIFTY_BOOSTER: 'qz-booster-half',
  THIRD_UMPIRE_BOOSTER: 'qz-booster-umpire',
  SHARE: 'qz-share',
  STREAK: 'qz-streak',
  BACK_ARROW: 'qz-arrow-back',
  CLOSE: 'qz-close'
};

export const rankMap = {
  1: 'first',
  2: 'second',
  3: 'third'
};

export const PARENT_COOKIE = '_URC';
export const PARENT_COOKIE_SECURE = '_USC';
export const GAME_COOKIE = 'Quiz_RAW';
export const GAME_COOKIE_SECURE = 'Quiz_007';

// export const HAS_PLAYED_AS_A_GUEST_USER = 'hasPlayedAsAGuestUser';
export const GUEST_USER_INFO = 'guestUserInfo';

export const LEADERBOARDS = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  OVERALL: 'overall'
};

export const LEADERBOARD_TABS = [
  {
    tabName: LEADERBOARDS.DAILY,
    label: 'DAILY'
  },
  {
    tabName: LEADERBOARDS.WEEKLY,
    label: 'WEEKLY'
  },
  {
    tabName: LEADERBOARDS.OVERALL,
    label: 'OVERALL'
  }
];
